import type { Result } from '@/stores/type/result.type'
import { CHART_AXIS_GROUPINGS, DEFAULT_CHART_AXIS_GROUPING } from '@/constants/chartConfiguration'

export type TrajectoryIndexByName = Map<string, number>

export const dimensionValues = (result: Result, dimension: string): string[] => {
  switch (dimension) {
    case CHART_AXIS_GROUPINGS.MATERIAL:
      return result.material_display_name ? [result.material_display_name] : []
    case CHART_AXIS_GROUPINGS.BUILDING_BLOCK:
      return result.building_block_name ? [result.building_block_name] : []
    case CHART_AXIS_GROUPINGS.LABEL:
      return result.quantity_labels ?? []
    case CHART_AXIS_GROUPINGS.LOCATION:
    default:
      return result.code_name ? [result.code_name] : []
  }
}

export const collectDimensionValues = (results: Result[], dimension: string): string[] => {
  const unique = new Set<string>()
  for (const result of results) {
    for (const value of dimensionValues(result, dimension)) {
      if (value) unique.add(value)
    }
  }
  return Array.from(unique).sort()
}

export const buildTrajectLabels = (
  results: Result[],
  grouping: string = DEFAULT_CHART_AXIS_GROUPING
) => collectDimensionValues(results, grouping)

export const buildMaterialCategories = (results: Result[]) =>
  collectDimensionValues(results, CHART_AXIS_GROUPINGS.MATERIAL)

export const resolveTrajectoryIndices = (
  result: Result,
  grouping: string,
  trajectoryByName: TrajectoryIndexByName
): number[] => {
  const indices: number[] = []
  for (const value of dimensionValues(result, grouping)) {
    const index = trajectoryByName.get(value)
    if (index !== undefined) indices.push(index)
  }
  return indices
}
